import script from "./component_wave.vue?vue&type=script&setup=true&lang=js"
export * from "./component_wave.vue?vue&type=script&setup=true&lang=js"

import "./component_wave.vue?vue&type=style&index=0&id=da9561d6&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da9561d6"]])

export default __exports__